import { getCookie } from "../hooks/helpers";
import { webView } from "../variables/webView";

/**
 * Note: In Twig templates, use server-side functions instead of JS cookies:
 * - get_web_view_version() — returns app_web_view_version
 * - is_web_view() — checks if opened via WebView
 */

const MIN_STRUCTURED_VERSION = 3;
export const MIN_FIRST_SCREEN_VARIANT_VERSION = 5;

const EVENT_TYPE = {
  ANALYTICS: "analytics_event",
  DOWNLOAD: "download",
  REDIRECT: "redirect",
};

function getWebViewVersion() {
  const version = getCookie("app_web_view_version");
  return version ? parseInt(version, 10) : null;
}

function isStructuredEvents() {
  const version = getWebViewVersion();
  return version !== null && version >= MIN_STRUCTURED_VERSION;
}

function postMessage(data) {
  if (!webView) return;

  if (typeof data === "object") {
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
  } else {
    window.ReactNativeWebView.postMessage(data);
  }
}

function sendEvent(type, payload) {
  if (!webView) return;

  if (isStructuredEvents()) {
    postMessage({ type, payload });
  } else {
    postMessage(payload);
  }
}

export const WebViewEventService = {
  isStructuredEvents,
  getWebViewVersion,

  subscriptionLite() {
    sendEvent(EVENT_TYPE.ANALYTICS, "app_subscription_lite");
  },

  subscriptionPremium() {
    sendEvent(EVENT_TYPE.ANALYTICS, "app_subscription_premium");
  },

  customizeQr() {
    sendEvent(EVENT_TYPE.ANALYTICS, "app_customize_qr");
  },

  selectQrType() {
    sendEvent(EVENT_TYPE.ANALYTICS, "app_type_qr");
  },

  downloadQr() {
    sendEvent(EVENT_TYPE.ANALYTICS, "app_download_qr");
  },

  linkToMyQrCodes() {
    sendEvent(EVENT_TYPE.REDIRECT, "my_qr_codes");
  },

  linkToPricing() {
    sendEvent(EVENT_TYPE.REDIRECT, "pricing");
  },

  downloadImage(payload) {
    sendEvent(EVENT_TYPE.DOWNLOAD, payload);
  },

  redirect(payload) {
    sendEvent(EVENT_TYPE.REDIRECT, payload);
  },
};

export default WebViewEventService;
